import { DraftReturn } from "@redotech/redo-model/draft-return/draft-return";
import { Return } from "@redotech/redo-model/return";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Flowchart } from "@redotech/redo-web/flowchart";
import { memo } from "react";
import * as resetModalCss from "./reset-modal.module.css";
import { useReturnPathModal } from "./use-return-path-modal";

export const ReturnPathModal = memo(function ReturnPathModal({
  open,
  onClose,
  return: return_,
  draftReturn,
  returnPathItemId,
}: {
  open: boolean;
  onClose: () => void;
  return: Return;
  draftReturn: DraftReturn;
  returnPathItemId?: string;
}) {
  const { flowchartProps } = useReturnPathModal({
    return_,
    draftReturn,
    returnPathItemId,
  });
  return (
    <RedoModal
      buttonPlacement="full"
      isOpen={open}
      modalSize="lg"
      onModalCloseRequested={onClose}
      primaryButton={{
        text: "close",
        onClick: () => {
          onClose();
        },
      }}
      title="Return flow path"
    >
      <Flex dir="column" gap="2xl">
        <div className={resetModalCss.flowchartContainer}>
          <Flowchart {...flowchartProps} showBorder />
        </div>
      </Flex>
    </RedoModal>
  );
});
